import axios from "axios";
import {ResponseModel} from "../../models/ResponseModel";
import { ACCOUNT_BOOKS_ENDPOINT } from "../../constants/endpoints";
import { SaleRowCompareModel, SaleRowSearchModel, SalesBoookListModel } from "../../models/account-books/SalesAccount";
import { WarehouseListModel, WarehouseRowSearchModel } from "../../models/account-books/WarehousesAccount";
import { ExpenseListModel, ExpenseRowSearchModel } from "../../models/account-books/ExpensesAccount";
import { TaxListModel, TaxRowSearchModel } from "../../models/account-books/TaxAccount";
import { PayrollListModel, PayrollPaymentModel, PayrollRowModel, PayrollRowSearchModel } from "../../models/account-books/PayrollAccount";
import { CashListModel } from "../../models/account-books/CashBookAccount";
import { BankBookRowSearchModel, BankListModel } from "../../models/account-books/BankBookAccount";
import { IAxiosSuccess } from "../../models/AxiosModel";
import { PaymentRowSearchModel } from "../../models/account-books/PaymentAccount";
import { SearchModel } from "../../models/account-books/AccountBooksReport";
import { IResponseModel } from "../../models/DashboardModel";

// Sales
export function getSalesBooks(search?: SaleRowSearchModel, compareRows?: SaleRowCompareModel[]) {
  let params: any = {...search}
  if (compareRows?.length && compareRows?.length > 0) {
    params = {...search, compare_rows: JSON.stringify(compareRows)}
  }
  return axios.get<SalesBoookListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/sales`, {params})
}

export function getMisingSalesBooks(search: SaleRowSearchModel, compareRows: SaleRowCompareModel[]) {
  let params = {...search, compare_rows: JSON.stringify(compareRows)}
  return axios.get<IAxiosSuccess>(`${ACCOUNT_BOOKS_ENDPOINT}/get-missing-sales`, {params})
}

export function exportSalesBooks(params?: SaleRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/sales-export`, {params, responseType: 'blob'})
}

// Warehouse
export function getWarehousesBooks(params?: WarehouseRowSearchModel) {
  return axios.get<WarehouseListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/warehouses`, {params})
}

export function exportWarehousesList(params?: SaleRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/warehouses-list-export`, {params, responseType: 'blob'})
}

export function exportWarehousesBooks(params?: WarehouseRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/warehouses-export`, {params, responseType: 'blob'})
}

export function refreshWarehousesBooks(params?: WarehouseRowSearchModel) {
  return axios.get<WarehouseListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/warehouses-refresh`, {params})
}

// Expense
export function getExpensesBooks(params?: ExpenseRowSearchModel) {
  return axios.get<ExpenseListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/expenses`, {params})
}

export function exportExpensesBooks(params?: ExpenseRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/expenses-export`, {params, responseType: 'blob'})
}

// Tax
export function getTaxBooks(params?: TaxRowSearchModel) {
  return axios.get<TaxListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/tax`, {params})
}

export function exportTaxBooks(params?: TaxRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/tax-export`, {params, responseType: 'blob'})
}

// Payroll
export function getPayrollBooks(params?: PayrollRowSearchModel) {
  return axios.get<PayrollListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/payrolls`, {params})
}

export function exportPayrollBooks(params?: PayrollRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/payrolls-export`, {params, responseType: 'blob'})
}

export function updatePayroll(params: PayrollRowModel, month: string) {
  return axios.post<PayrollListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/payroll-update`, {...params, month})
}

export function createPayroll(params: PayrollPaymentModel, month: string) {
  return axios.post<PayrollListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/payroll-create`, {...params, month})
}

// When importing payments we need to send an Excel file. the calling
// component converts an array of rows into a workbook blob and packages it
// inside a FormData instance. the backend controller expects `file` in the
// request so we post the form data directly.
export function importPayments(formData: FormData) {
  return axios.post<IAxiosSuccess>(
    `${ACCOUNT_BOOKS_ENDPOINT}/import-payments`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  )
}

// Cash
export function getPayments(params?: PaymentRowSearchModel) {
  return axios.get<CashListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/payment-account`, {params})
}

export function exportPayments(params?: PaymentRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/export-payment-account`, {params, responseType: 'blob'})
}

// Cash
export function getBankBooks(params?: BankBookRowSearchModel) {
  return axios.get<BankListModel>(`${ACCOUNT_BOOKS_ENDPOINT}/bank`, {params})
}

export function exportBankBooks(params?: BankBookRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/bank-export`, {params, responseType: 'blob'})
}

export function exportAccountBooks(params?: SaleRowSearchModel) {
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/export`, {params, responseType: 'blob'})
}

export function removePayments(ids: number[]) {
  return axios.post<ResponseModel>(`${ACCOUNT_BOOKS_ENDPOINT}/remove-payments`, {ids: [...ids]})
}

export function forceRemovePayment(ids: number[]) {
  return axios.post<ResponseModel>(`${ACCOUNT_BOOKS_ENDPOINT}/force-remove-payments`, {ids: [...ids]})
}

export function restorePayments(ids: number[]) {
  return axios.post<ResponseModel>(`${ACCOUNT_BOOKS_ENDPOINT}/restore-payments`, {ids: [...ids]})
}

export function getCurReport(params: SearchModel){
  return axios.get<IResponseModel>(`${ACCOUNT_BOOKS_ENDPOINT}/get-report-hist`, {params});
}

export function downloadReport(params: {report_id: number}){
  return axios.get(`${ACCOUNT_BOOKS_ENDPOINT}/download-report`, {params, responseType: 'blob'})
}